/**
 * Beginscherm-app (PWA, 19-10-2026, Jordy): "Zet op beginscherm" geeft een
 * eigen icoon en opent het dashboard zonder browserbalk. GEEN service worker
 * en geen offline: het oude dashboard had een caching-SW die na een uitrol
 * oude bundels bleef serveren (admin-dashboard/public/sw.js ruimt die op).
 *
 * NT en TT delen één bundel (zie test_beide_dashboards_dezelfde_bundel.py);
 * het merk komt uit config.json, dus het manifest wordt hier gekozen en niet
 * in index.html. Alleen op een telefoon (onder 900px of met touch als
 * hoofdinvoer): op desktop verschijnt er dan ook geen installeer-icoon in de
 * adresbalk en verandert er niets.
 */
import type { InstanceConfig } from './instance'
import { isMobiel } from './mobiel'

function voegToe(tag: 'link' | 'meta', attrs: Record<string, string>) {
  const el = document.createElement(tag)
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v)
  document.head.appendChild(el)
}

export function installeerPwa(cfg: InstanceConfig): void {
  const aanraak = typeof window.matchMedia === 'function'
    && window.matchMedia('(pointer: coarse)').matches
  if (!isMobiel() && !aanraak) return
  const merk = /talent/i.test(cfg.brand) ? 'tt' : 'nt'
  voegToe('link', { rel: 'manifest', href: `/manifest-${merk}.json` })
  voegToe('link', { rel: 'apple-touch-icon', href: `/icons/${merk}-180.png` })
  voegToe('meta', { name: 'mobile-web-app-capable', content: 'yes' })
  voegToe('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' })
  voegToe('meta', { name: 'apple-mobile-web-app-status-bar-style', content: 'black' })
  voegToe('meta', { name: 'apple-mobile-web-app-title', content: merk === 'tt' ? 'TT Chats' : 'NT Chats' })
}
